export function settingsSelector(state = {}) {
  return state?.settings || {};
}

export const imageEnhancementServiceUrlSelector = (state = {}) => {
  return state?.settings?.IMAGE_ENHANCEMENT_SERVICE_URL || '';
};
